import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { isBrasilSite } from '@panel/commons/helpers/siteUtils';
import { ButtonText } from '@panel/commons/lib/typography';
import DropdownDefault from '@panel/commons/lib/Dropdowns/DropdownDefault';
import DropdownPrimaryBtn from './dropdowns/DropdownPrimaryBtn';
import { Icon } from './icon/Icon';

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 16px;
`;

const StyledRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-between;
  text-transform: capitalize;
  margin-bottom: 10px;
  > button:hover {
    cursor: pointer;
  }
  > button:disabled {
    cursor: not-allowed;
  }
  > button:disabled path {
    fill: #7c98a7;
  }
`;

const StyledRowDropdowns = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-evenly;
  text-transform: capitalize;
  button {
    height: 30px;
    padding: 4px 8px;
    line-height: initial;
    text-transform: capitalize;
    border: 0;
  }
  button:hover {
    border: 0;
  }
  ul {
    overflow-y: scroll;
    max-height: 200px;
  }
  > div > div {
    min-width: 97px;
  }
`;

export default (years, months) => {
  return ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled
  }) => {
    moment.locale(isBrasilSite ? 'pt' : 'es');
    return (
      <StyledContainer>
        <StyledRow>
          <button
            type='button'
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
            data-panel='button-chevron-left'
          >
            <Icon size={200} name='chevronLeft' margin='0' dataPanel='chevronLeft' />
          </button>
          <ButtonText size={200}>{moment(date).format('MMMM YYYY')}</ButtonText>
          <button
            type='button'
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
            data-panel='button-chevron-right'
          >
            <Icon size={200} name='chevronRight' margin='0' dataPanel='chevronRight' />
          </button>
        </StyledRow>
        <StyledRowDropdowns>
          <DropdownDefault
            onSelectItem={(e, i) => changeMonth(months.findIndex(d => d.value === i.value))}
            options={months}
            dataPanel
          >
            <DropdownPrimaryBtn text={moment(date).format('MMMM')} size={100} dataPanel='month' />
          </DropdownDefault>
          <DropdownDefault
            onSelectItem={(e, i) => changeYear(years.find(d => d.value === i.value).value)}
            options={years}
            dataPanel
          >
            <DropdownPrimaryBtn text={moment(date).format('YYYY')} size={100} dataPanel='year' />
          </DropdownDefault>
        </StyledRowDropdowns>
      </StyledContainer>
    );
  };
};
